import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { UpdateProfileFormPage } from '../update-profile/update-profile-form';
import { UpdateProfileFormPageModule } from '../update-profile/update-profile-form.module';

@IonicPage()
@Component({
  selector: 'page-request-list',
  templateUrl: 'request-list.html',
})
export class RequestListPage{

	page_title="";
	details = [];

  constructor(public navCtrl: NavController,private translate: TranslateService, public navParams: NavParams) {
    this.details = navParams.get("details");	
    console.log(this.details);
  }
  editProfile(){
    this.navCtrl.push(UpdateProfileFormPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad  requestListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/request-list/request-list.ts